import { MobileFirebaseProviderContext } from "./MobileFirebaseProviderContext";
import { useMemo, useState } from "react";
import { useLocation } from "react-router";
import useEffectOnce from "../../../hooks/useEffectOnce";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

function MobileFirebaseProvider(props) {
    const location = useLocation();
    const [firebaseToken, setFirebaseToken] = useState('');

    useEffectOnce(() => {
        const params = new URLSearchParams(location.search);
        const firebaseToken = params.get('firebase_token')
        if (firebaseToken) {
            setFirebaseToken(firebaseToken);
            cookies.set('firebase_token', firebaseToken, { path: '/', maxAge: 60 * 60 * 24 * 365 });
        }
    });

    const value = useMemo(() => ({
        firebaseToken,
    }), [firebaseToken]);

    return <MobileFirebaseProviderContext.Provider value={value}>
        {props.children}
    </MobileFirebaseProviderContext.Provider>
}

export default MobileFirebaseProvider;
